import RecordEditationService from './record-editation.service';
import type {IQService} from 'angular';
import type {RecordEditationActionFactory} from './record-editation';
import type {RecordEditation} from 'typings/portaro.be.types';
import type EditableFieldTypeDataService from './editable-field-type.data-service';

/*@ngInject*/
export default function recordEditationServiceFactory(recordEditationActionFactory: RecordEditationActionFactory,
                                                      editableFieldTypeDataService: EditableFieldTypeDataService,
                                                      $q: IQService): RecordEditationServiceFactory {
    return {
        createService: (recordEditation, focusedFieldTypeId) =>
            new RecordEditationService(recordEditation, $q, recordEditationActionFactory, editableFieldTypeDataService, focusedFieldTypeId)
    };
}

recordEditationServiceFactory.factoryName = 'recordEditationServiceFactory';

export interface RecordEditationServiceFactory {
    createService(recordEditation: RecordEditation, focusedFieldTypeId?: string): RecordEditationService;
}
